/** Why the server held an import row for an address pick (#3169, #3201). */
export var AddressPickReason;
(function (AddressPickReason) {
    /** Google answered in another commune: only accepted one row at a time. */
    AddressPickReason["COMMUNE"] = "COMMUNE";
    /** Same commune, a partial match that did not keep the cell's street. */
    AddressPickReason["STREET"] = "STREET";
})(AddressPickReason || (AddressPickReason = {}));
/**
 * The columns the sites import reads (`readRowCells`), in guide order: the three
 * required ones first (#2824). Any other header in a file is ignored. The API's
 * `.xlsx` template is built from this list.
 */
export const SITE_IMPORT_COLUMNS = [
    'nom',
    'adresse',
    'ref_interne',
    'adresse_complement',
    'activite',
    'statut',
    'type',
    'categorie',
    'tag',
    'contact_prenom',
    'contact_nom',
    'contact_email',
    'contact_telephone',
    'gestionnaire_email',
    'instructions_acces',
    'contraintes_acces',
    'entite_facturation_partagee',
    'entite_facturation',
    'facturation_nom',
    'facturation_adresse',
    'facturation_complement',
    'facturation_cp',
    'facturation_ville',
    'facturation_departement',
    'facturation_region',
    'facturation_pays',
    'facturation_siren',
    'facturation_siret',
    'facturation_tva',
    'instructions_facturation',
    'contact_facture_nom',
    'contact_facture_email',
    'contact_facture_telephone',
];
export const SITE_IMPORT_TEMPLATE_FILE_NAME = 'modele_import_sites.xlsx';
